<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th class="text-center">Valor R$</th>
        <th class="text-center">Vencimento</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(installment, key) in items" :key="key">
        <td align="center">
          <strong>{{ key + 1 }}</strong>
        </td>
        <td>
          <InputMoney
            :id="key"
            :precision="2"
            :disabled="lastIndex === key"
            :onKeyup="changeRangeValue"
            v-model="installment.value"
          />
        </td>
        <td>
          <InputDate
            :id="'paymentDate-' + key"
            :range="false"
            v-model="installment.date"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { InputDate, InputMoney } from '@/components/Form';
import { round } from 'lodash';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import InstallmentsMixin from '@/modules/Application/mixins/InstallmentsMixin';

export default {
  name: 'InstallmentTableV2',
  mixins: [FormatMixin, InstallmentsMixin],
  components: {
    InputMoney,
    InputDate,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    totalPaymentAmount: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      currentInstallment: null,
      fields: [
        { key: 'value', label: 'Valor R$', class: 'text-center' },
        { key: 'date', label: 'Vencimento', class: 'text-center' },
      ],
    };
  },
  computed: {
    itemsData() {
      return this.items;
    },
    lastIndex() {
      return this.itemsData.length - 1;
    },
  },
  methods: {
    apportionInstallments(key) {
      const totalPaymentAmount = this.valorUS(this.totalPaymentAmount);

      return this.itemsData.map((e, idx) => {
        if (this.valorUS(e.value) <= 0) e.value = this.currentInstallment;
        if (idx <= key) return e;

        const value = round(
          (totalPaymentAmount - this.currentInstallment) /
            (this.itemsData.length - (key + 1)),
          2,
        );

        return {
          ...e,
          value,
        };
      });
    },
    apportionRemainingInstallments(
      preCalculatedInstallments,
      index,
      remainingAmount,
    ) {
      const totalPaymentAmount = this.valorUS(this.totalPaymentAmount);

      return preCalculatedInstallments.map((e, idx) => {
        if (idx <= index) return e;

        const recalculatedInstallment = round(
          (totalPaymentAmount - (this.currentInstallment + remainingAmount)) /
            (this.itemsData.length - (index + 1)),
          2,
        );

        return {
          ...e,
          value: recalculatedInstallment,
        };
      });
    },
    async changeRangeValue(index) {
      const totalPaymentAmount = this.valorUS(this.totalPaymentAmount);
      const [installment] = this.itemsData.filter((_, idx) => idx === index);
      this.currentInstallment = this.valorUS(installment.value) || 0.01;

      if (this.currentInstallment >= totalPaymentAmount) {
        this.itemsData[index].value = 0.01;
        return;
      }

      const preCalculatedInstallments = this.apportionInstallments(index);

      const remainingAmount =
        this.calcTotalRange(preCalculatedInstallments) - totalPaymentAmount;

      if (!remainingAmount) {
        this.$emit('changeInstallments', preCalculatedInstallments);
        return;
      }

      const calculatedInstallments = this.apportionRemainingInstallments(
        preCalculatedInstallments,
        index,
        remainingAmount,
      );

      if (this.calculatedInstallmentsExceedsTotal(calculatedInstallments)) {
        this.itemsData[index].value = 0.01;
        return;
      }

      calculatedInstallments[this.lastIndex].value = this.adjustDifference(
        calculatedInstallments,
        totalPaymentAmount,
      );

      this.$emit('changeInstallments', calculatedInstallments);
    },
    calculatedInstallmentsExceedsTotal(calculatedInstallments) {
      return calculatedInstallments.some((i) => this.valorUS(i.value) < 0);
    },
    adjustDifference(calculatedInstallments, totalPaymentAmount) {
      const diff = round(
        this.calcTotalRange(calculatedInstallments) - totalPaymentAmount,
        2,
      );
      const lastIndexValue = calculatedInstallments[this.lastIndex].value;

      if (diff) return lastIndexValue - diff;

      return lastIndexValue;
    },
  },
};
</script>
